export const generatingColor = () => {
  const colorsAvatar = [
    "#E67E22",
    "#2ECC71",
    "#3498DB",
    "#8E44AD",
    "#E74C3C",
    "#1ABC9C",
    "#2C3E50",
  ];
  const index = Math.floor(Math.random() * 7);
  return colorsAvatar[index];
};

export const avatarSymbols = (data: string) => {
  return data
    .split(" ")
    .map((el) => el.substring(0, 1))
    .join("")
    .toUpperCase();
};
